<template>
	<v-app v-if="!loading" class="landing" :style="{ background: $vuetify.theme.themes[theme].landingBackground }">
		<default-bar />

		<default-view />

		<default-footer />

	</v-app>
</template>

<script>
	import { get } from 'vuex-pathify'
	import router from '@/router'
	import { setCookie, getCookie } from '@/util/helpers'
	import api from '@/util/app-api'

	export default {
		name: 'DefaultLayout',

		components: {
			DefaultBar: () => import(
				/* webpackChunkName: "default-app-bar" */
				'./AppBar'
			),
			DefaultFooter: () => import(
				/* webpackChunkName: "default-footer" */
				'./Footer'
			),
			DefaultView: () => import(
				/* webpackChunkName: "default-view" */
				'./View'
			),
		},
		data() {
			return {
				loading: true,
			}
		},
		computed: {
			theme() {
				return (this.$vuetify.theme.dark) ? 'dark' : 'light'
			},
			...get('siteConfig', [
				'isCloud', 'routeToPlansAsDefault'
			])
		},
		created() {
			if (!this.isCloud) {
				if (this.routeToPlansAsDefault)
					this.$router.replace('/cl/plans').catch(() => { })
				else
					router.push({ name: 'Login' }).catch(() => { })
				this.loading = false
			} else {
				this.manageParkDomain()
			}
		},
		mounted() {
			this.manageAffiliate()
		},
		methods: {
			manageAffiliate() {
				if (!this.$route.query.aff)
					return
				const localAff = getCookie('aff')
				if (localAff)
					return
				setCookie('aff', this.$route.query.aff, 90)
			},
			async manageParkDomain() {
				let hostname = window.location.hostname
				if (hostname.indexOf('localhost') > -1 || hostname.indexOf('jetaqsaat') > -1) {
					this.loading = false
					return
				}
				var code = await api.post('account/GetCustomerCodeByDomain/' + hostname, {}, { authHeader: false, contentType: 'application/json' })
					.catch(err => {
						console.log("🚀 ~ manageParkDomain ~ err:", err)
					})
				this.loading = false
				if (code)
					this.$router.replace(`/cl/plans/${code}`).catch(() => { })
			}
		},
	}
</script>
